import React, { Component } from 'react'
import PropTypes from 'prop-types'

import FeedbackForm from './../block/FeedbackForm'

import { Button } from 'react-bootstrap'

import styles from './../blocks.module.sass'

export default class Main extends Component {

  constructor(props) {
    super(props)

    this.state = {
      show: false,
      shop: ``,
      show_feedback: false
    }
  }

  show_feedback( shop ) {
    this.setState({
      shop: shop,
      show_feedback: true
    })
  }
  close_feedback = () => {
    this.setState({
      show_feedback: false
    })
  }

  changeSize = ( size ) => {
    const { product, color, changeProduct } = this.props

    if(product.variants != null) {
      product.variants.map( ( variant ) => {
        if( variant.colorName == color && variant.size == size ) changeProduct( product.msid, variant.msid )
      })
    }
  }

  changeShow = () => {
    this.setState({
      show: !this.state.show
    })
  }

  render() {

    const { shops: shopsRaw, color, size, product } = this.props,
    { show, shop, show_feedback } = this.state

    // Преобразуем объект с числовыми ключами в массив, если нужно
    const shops = Array.isArray(shopsRaw) ? shopsRaw : Object.values(shopsRaw)

    var count = 0

    try {
      if (product.variants != null) {
        shops.forEach((elm) => {
          elm.colors?.[color]?.forEach((size_e) => {
            if (size === size_e) count++;
          });
        });
      } else {
        count = 1;
      }
    } catch (e) {
      // window.console.log( e )
    }

    if(shops.length > 0) return (
      <>
        <div className={styles.block_product_start_description}>
          <div className='d-flex align-items-center justify-content-between'>
            <div className={styles.block_product_start_description_title}>Наличие в магазинах</div>
            <svg onClick={() => this.changeShow()} className={show ? styles.block_product_start_description_icon_open : styles.block_product_start_description_icon} width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11 6L6 1L1 6" stroke="black"/>
            </svg>
          </div>
          <div className={show ? styles.block_product_start_description_text_open : styles.block_product_start_description_text}>
            {shops.map( ( elm, k ) => {
              if(color in elm.colors) return (
                <div key={k} className={styles.block_product_shop}>
                  <div className='d-flex flex-column flex-sm-row align-items-start justify-content-between'>
                    <div>
                      <div className={styles.block_product_shop_name}>{elm.name}</div>
                      <div className={styles.block_product_shop_podpis}>
                        <dim dangerouslySetInnerHTML={{__html: elm.description}} />
                        <svg className={styles.block_product_shop_podpis_icon} width="2" height="2" viewBox="0 0 2 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="0.964208" cy="0.964208" r="0.964208" fill="black" fillOpacity="0.6"/>
                        </svg>
                        <span>{elm.raspisanie}</span>
                      </div>
                    </div>
                    {/* 
                    <Button onClick={() => this.show_feedback( elm.name )} className={styles.block_product_shop_btn} variant="dark">Зарезервировать</Button>
                    */}
                  </div>
                  {'colors_new' in elm ?
                    <>
                      {elm.colors_new[ product.msid ]?.length > 0 &&
                        <>
                          {elm.colors_new[ product.msid ][0] != '' &&
                            <div className={styles.block_product_shop_sizes}>
                              <div className={styles.block_product_shop_sizes_title}>Размеры в наличии</div>
                              {elm.colors_new[ product.msid ].filter((item, index) => {
                                  return elm.colors_new[ product.msid ].indexOf(item) === index
                              }).sort( (a, b) => {
                                return Number(a) - Number(b)
                              }).map( ( size_e, j ) => {
                                return (
                                  <div onClick={() => this.changeSize( size_e )} className={size_e == size ? styles.block_product_sizes_el_active : styles.block_product_sizes_el} key={j}>{size_e}</div>
                                )
                              })}
                            </div>
                          }
                        </>
                      }
                    </>
                    :
                    <>
                      {elm.colors[ color ][0] != '' &&
                        <div className={styles.block_product_shop_sizes}>
                          <div className={styles.block_product_shop_sizes_title}>Размеры в наличии</div>
                          {elm.colors[ color ].filter((item, index) => {
                              return elm.colors[ color ].indexOf(item) === index
                          }).sort( (a, b) => {
                            return Number(a) - Number(b)
                          }).map( ( size_e, j ) => {
                            return (
                              <div onClick={() => this.changeSize( size_e )} className={size_e == size ? styles.block_product_sizes_el_active : styles.block_product_sizes_el} key={j}>{size_e}</div>
                            )
                          })}
                        </div>
                      }
                    </>
                  }
                </div>
              )
            })}
          </div>
        </div>
        <FeedbackForm
          title={`Зарезервировать`}
          text={``}
          btn={``}
          data={[
            {
              name: `Магазин`,
              value: shop
            },
            {
              name: `Товар`,
              value: product.name
            },
            {
              name: `Код товара`,
              value: product.code || ``
            },
            {
              name: `Код варианта`,
              value: product.variants?.find( ( v ) => v.colorName == color && v.size == size )?.code || ``
            },
            {
              name: `Цена`,
              value: product.price
            },
            {
              name: `Цвет`,
              value: color
            },
            {
              name: `Размер`,
              value: size
            }
          ]}
          show={show_feedback}
          handleClose={this.close_feedback}
        />
      </>
    )
  }
}

Main.propTypes = {
  shops: PropTypes.array,
  color: PropTypes.string,
  size: PropTypes.string,
  product: PropTypes.object,
  changeProduct: PropTypes.func
}